import { Icon, IconArrowLeft, IconArrowRight } from '@flixbus/honeycomb-icons-react';
import { Pager, PagerItem, Text } from '@flixbus/honeycomb-react';

import { usePagination, LEFT_DOTS, RIGHT_DOTS } from './usePagination';

import styles from './styles.module.css';

const Pagination = ({ activePage, setActivePage, pageCount }) => {
	const {
		paginationRange,
		rangeLabel,
		showPagination,
		isPrevDisabled,
		isNextDisabled,
		goToPrevPage,
		goToNextPage,
		goToPage,
		handleDotsClick,
	} = usePagination({ activePage, setActivePage, pageCount });

	if (!showPagination) return null;

	return (
		<div className={styles.wrapperPagination}>
			<Pager Elem="button" aria-label="Table pagination">
				<PagerItem
					Elem="button"
					aria-label="Previous page"
					disabled={isPrevDisabled}
					onClick={goToPrevPage}
				>
					<Icon InlineIcon={IconArrowLeft} />
				</PagerItem>
				{paginationRange.map((item) => {
					if (item === LEFT_DOTS || item === RIGHT_DOTS) {
						return (
							<PagerItem
								key={item}
								Elem="button"
								onClick={() => handleDotsClick(item === LEFT_DOTS ? 'left' : 'right')}
								aria-label={item === LEFT_DOTS ? 'Jump back 5 pages' : 'Jump forward 5 pages'}
							>
								...
							</PagerItem>
						);
					}
					return (
						<PagerItem key={item} active={activePage === item} onClick={() => goToPage(item)}>
							{item + 1}
						</PagerItem>
					);
				})}
				<PagerItem
					Elem="button"
					aria-label="Next page"
					disabled={isNextDisabled}
					onClick={goToNextPage}
				>
					<Icon InlineIcon={IconArrowRight} />
				</PagerItem>
			</Pager>
			{rangeLabel && <Text extraClasses={styles.counterPagination}>{rangeLabel}</Text>}
		</div>
	);
};

export default Pagination;
